import { selectActiveSortingType } from "features/category/categorySlice";
import { filtersToQuery } from "features/Filters/components/FilterRow";
import {
  selectActiveFilters,
  setActiveFilters,
  setActiveFiltersCount,
} from "features/Filters/filtersSlice";
import { PageWithFilterType, ActiveFilter } from "features/Filters/types";
import {
  getActiveFiltersByName,
  removeEmptyStrings,
  getActiveFiltersCount,
} from "features/Filters/utils";
import { setPage } from "features/pagination/paginationSlice";
import { SortingType } from "pages/category/types";
import React, { useRef, useState } from "react";
import { useSelector, useDispatch, batch } from "react-redux";
import { useLocation } from "react-router-dom";

export const useSetFilters = (
  name: string,
  pageType: PageWithFilterType,
  fetchFN: (
    activefilters: ActiveFilter[],
    page: number,
    sortingType: SortingType,
    isPromoPage?: boolean
  ) => void
) => {
  const activeFilters = useSelector(selectActiveFilters);
  const location = useLocation();

  let activeRowFilters = getActiveFiltersByName(name, activeFilters);
  const dispatch = useDispatch();
  const activeCategorySortingType = useSelector(selectActiveSortingType);

  const setFilter = (filterString: string) => {
    let newFilters: string[] = [...activeRowFilters];
    if (newFilters.length > 0 && name === "price") {
    } else if (newFilters.includes(filterString)) {
      if (filterString === "Таванен") {
        const specificFilters = ["Таванен", "Подово-таванен"];
        specificFilters.forEach((filter) => {
          const idxOfFilterString = activeRowFilters.indexOf(filter);
          newFilters.splice(idxOfFilterString, 1);
        });
      } else {
        const idxOfFilterString = activeRowFilters.indexOf(filterString);
        newFilters.splice(idxOfFilterString, 1);
      }
    } else {
      if (filterString === "Таванен") {
        const specificFilters = ["Таванен", "Подово-таванен"];
        specificFilters.forEach((filter) => {
          newFilters.push(filter);
        });
      } else {
        newFilters.push(filterString);
      }
    }

    let updatedFilters = [...activeFilters];
    let filterToUpdate = updatedFilters.find(
      (updatedFilter) => updatedFilter.name === name
    );
    if (name === "price" && filterToUpdate) {
      let idxOfFilter = updatedFilters.indexOf(filterToUpdate);
      updatedFilters[idxOfFilter] = {
        name,
        activeFilters: [filterString],
      };
    } else if (filterToUpdate) {
      let idxOfFilter = updatedFilters.indexOf(filterToUpdate);
      updatedFilters[idxOfFilter] = {
        name,
        activeFilters: newFilters.filter(removeEmptyStrings),
      };
    } else {
      updatedFilters.push({
        name,
        activeFilters: newFilters.filter(removeEmptyStrings),
      });
    }
    const activeFiltersCount = getActiveFiltersCount(updatedFilters);

    batch(() => {
      dispatch(setActiveFilters(updatedFilters));
      dispatch(setActiveFiltersCount(activeFiltersCount));
      dispatch(setPage(1));
      dispatch(
        fetchFN(
          updatedFilters,
          1,
          activeCategorySortingType,
          location.pathname === "/promotions"
        )
      );
    });

    window.history.pushState(
      null,
      "Категория",
      `/${pageType}?page=${1}&${filtersToQuery(updatedFilters).join("&")}`
    );
  };
  return setFilter;
};
